// Aviso de Evolução de Patente (spec #265, ticket #268) -- mesmo padrão de
// useMeritPendingPoll.js: sem evento de socket pra isso, um endpoint de
// contagem dedicado (GET /admin/rank-promotions/pending-count) + poll
// espaçado é suficiente pra um indicador informativo.
//
// A entrega também pode ser confirmada pelo app do Taualegre (mesma linha no
// banco); o poll curto traz essa mudança pro badge sem depender de F5, e quem
// confirma/revoga aqui chama refreshRankPromotionPendingCount pra atualizar o
// badge na hora.
import { onMounted, onUnmounted } from 'vue'
import { getPendingRankPromotionsCount } from '@/services/adminService'
import { useAuthStore } from '@/stores/auth.store'
import { setNotificationCount, canSeeNotificationSource } from './registry'

const KEY     = 'patente-promocao-pendente'
const POLL_MS = 300_000 // 5min -- indicador informativo, não precisa de tempo real

export async function refreshRankPromotionPendingCount() {
  try {
    const { data } = await getPendingRankPromotionsCount()
    setNotificationCount(KEY, data.count)
  } catch {
    // Falha de rede não deve gerar erro visível por causa de um badge --
    // mantém a última contagem conhecida até o próximo poll funcionar.
  }
}

export function useRankPromotionPendingPoll() {
  let timer = null
  const auth = useAuthStore()

  function tick() {
    if (document.hidden) return
    refreshRankPromotionPendingCount()
  }

  onMounted(() => {
    // Perfil sem acesso (ex.: Banqueiro) não consulta: o backend responderia 403 a cada ciclo.
    if (!canSeeNotificationSource(KEY, auth.role)) return
    refreshRankPromotionPendingCount()
    timer = setInterval(tick, POLL_MS)
  })

  onUnmounted(() => {
    if (timer) clearInterval(timer)
  })
}
